import { useDashboardTopCoins } from "@shared/features/dashboard/hooks";
import styled from "styled-components";
import Flex from "common/Boxes/Flex";
import Text from "common/Typography/Text";
import LiveSymbolAvgPrice from "common/LiveComponents/LiveSymbolAvgPrice";
import LiveAvgPriceChange from "common/LiveComponents/LiveAvgPriceChange";
import { DISPLAY_CURRENCIES } from "common/constants";
import React from "react";

const TopCoinsPrice = () => {
  const {
    displayCurrency,
    selectedIndex,
    onChangeSelectedIndex,
    getSymbolPricePrecision,
    assetSummary,
    fulfilledTimeStamp,
  } = useDashboardTopCoins();

  const priceAndChange = Object.entries(assetSummary || {})?.map(
    ([coin, value], index: number) => {
      return (
        <PriceChangeWrapper key={index} $selected={selectedIndex === index}>
          <LiveSymbolAvgPrice
            key={`${coin}_price`}
            symbol={coin}
            initialPrice={value[displayCurrency]?.[0]}
            precision={getSymbolPricePrecision(coin)}
            fontSize={24}
            iconStyle={{
              marginRight: 2,
              fontSize: displayCurrency === DISPLAY_CURRENCIES.BTC ? 16 : 24,
            }}
            initialPriceTimestamp={fulfilledTimeStamp}
          />
          <LiveAvgPriceChange
            key={`${coin}_change`}
            symbol={coin}
            initialChange={value[displayCurrency]?.[2] / 100}
            arrowStyle={{ width: 8 }}
            initialChangeTimestamp={fulfilledTimeStamp}
          />
        </PriceChangeWrapper>
      );
    }
  );

  const coinsList = (
    <CoinsListWrapper>
      {Object.keys(assetSummary || {})?.map((coin: string, index: number) => {
        return (
          <CoinButton
            key={index}
            $selected={selectedIndex === index}
            onClick={() => onChangeSelectedIndex(index)}
          >
            {coin}
          </CoinButton>
        );
      })}
    </CoinsListWrapper>
  );

  return (
    <>
      {coinsList}
      {priceAndChange}
    </>
  );
};

export default React.memo(TopCoinsPrice);

const PriceChangeWrapper = styled(Flex)<{ $selected: boolean }>`
  justify-content: center;
  column-gap: 8px;
  ${(p) =>
    !p.$selected &&
    `
     opacity: 0;
     height: 0;
  `};
`;
const CoinsListWrapper = styled(Flex)`
  margin-bottom: 12px;
  justify-content: center;
  column-gap: 32px;
`;
const CoinButton = styled(Text)<{ $selected?: boolean }>`
  cursor: pointer;
  color: ${(p) =>
    p.$selected ? p.theme.colors.primaryBlue : p.theme.colors.secondaryGrey};
`;
